import React, {useState} from 'react';
import {ConfirmDialog} from 'src/design/molecules/ConfirmDialog';
import {Textbox} from 'src/design/atoms/Textbox';
import {ACKNOWLEDGED_TEXT} from 'src/shared/constants/constants';
import type {IStateMachineTransition} from 'src/types/StateMachine';

export interface AcknowledgementTransitionButtonProps {
  transition: IStateMachineTransition;
  executeTransition: (
    transition: IStateMachineTransition,
    note?: string
  ) => void | Promise<void>;
  /** Renders the trigger; `onClick` opens the dialog or executes directly. */
  renderButton: (onClick: () => void) => React.ReactNode;
}

export const AcknowledgementTransitionButton: React.FC<
  AcknowledgementTransitionButtonProps
> = ({transition, executeTransition, renderButton}) => {
  const [opened, setOpened] = useState(false);
  const [comment, setComment] = useState('');

  const handleClick = () => {
    if (transition.acknowledgementRequired) {
      setOpened(true);
    } else {
      void executeTransition(transition);
    }
  };

  return (
    <>
      {renderButton(handleClick)}
      {transition.acknowledgementRequired === true && (
        <ConfirmDialog
          size="md"
          opened={opened}
          title="Acknowledgement"
          body={
            <>
              <p>{transition.acknowledgementText ?? ACKNOWLEDGED_TEXT}</p>
              {transition.acknowledgementComment && (
                <Textbox
                  label="Note"
                  helperText="Have something else to add? Enter your comment here."
                  multiline={true}
                  minRows={3}
                  maxRows={6}
                  value={comment}
                  onChangeCallback={event => setComment(event.target.value)}
                />
              )}
            </>
          }
          buttonTextYes="Yes, I'm sure"
          onClose={() => setOpened(false)}
          onConfirm={() => {
            setOpened(false);
            void executeTransition(transition, comment);
            setComment('');
          }}
        />
      )}
    </>
  );
};
